import React from "react";

import Slider from "react-slick";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Testimonials = () => {
  const reviews = [
    {
      name: "Arlen Oliveira",
      src: "images/testimonial/client-sm-1.jpg",
      desc: "“Melhor app de montagem de times justos. Gostei demais S2”",
    },
    {
      name: "Pablo Sidarta",
      src: "images/testimonial/client-sm-2.jpg",
      desc: "“Usamos o app num torneio e usando todas as características do jogador, os times ficarem super equilibrados! ”",
    },
    {
      name: "Roiz 77",
      src: "images/testimonial/client-sm-3.jpg",
      desc: "“Adquiri a versão Premium para gerenciar nossa pelada. Ótimo aplicativo. A possibilidade de acrescentar estatísticas é nota 10.”",
    },
    {
      name: "Keven",
      src: "images/testimonial/client-sm-4.jpg",
      desc: "“Muito bom, recomendo pra caramba!!”",
    },
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section
      id="testimonial"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">O que dizem os nossos usuários</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Quem joga com o Pelada+ não quer saber de outro jeito. Veja o que a galera anda falando sobre o app.
        </p>
        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((review, index) => (
              <div
                className="item testimonial border rounded text-center p-4"
                key={index}
              >
                <span className="text-9 text-body-tertiary opacity-2">
                  <i className="fa fa-quote-left" />
                </span>
                <p>{review.desc}</p>
                <img
                  className="img-fluid d-inline-block w-auto rounded-circle shadow-sm border"
                  src={review.src}
                  alt=""
                />
                <strong className="d-block fw-500">{review.name}</strong>{" "}
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
